<div class="rel">
  <div class="rel__head"><span>Empresa</span><span>Vínculos identificados</span></div>
  @for (item of visao().empresas; track item.empresa.id) {
    <div class="rel__row">
      <div class="rel__company">
        <div class="rel__line">
          <span class="badge" [class]="'badge ' + badge(item.empresa).classe">{{
            badge(item.empresa).texto
          }}</span>
          <span class="rel__name">{{ item.empresa.rotulo }}</span>
          @if (item.empresa.situacao && alerta(item.empresa)) {
            <span class="badge badge--alert">{{ item.empresa.situacao }}</span>
          }
        </div>
        @if (item.empresa.cnpj) {
          <p class="rel__doc">{{ item.empresa.cnpj | vaultMaskCnpj }}</p>
        }
      </div>
      <div class="rel__links">
        @for (v of item.vinculos; track v.id + '-' + $index) {
          <span class="chip"
            ><span class="chip__main">{{ v.rotulo }}</span>
            @if (v.papel) {
              <span class="chip__role">{{ v.papel }}</span>
            }
          </span>
        } @empty {
          <span class="muted">Sem vínculo direto na profundidade selecionada.</span>
        }
      </div>
    </div>
  }
</div>
